module.exports = __webpack_public_path__ + "static/media/Home-X-01.26affba7.png";